<script lang="ts" setup>
import type { EditorialAuthenticityProps } from '@design-system/components/Editorial/EditorialAuthenticity.props'
import EditorialAuthenticity from '@design-system/components/Editorial/EditorialAuthenticity.vue'
import type { EditorialSocialWallProps } from '@design-system/components/Editorial/EditorialSocialWall.props'
import type { UIMediaProps } from '@design-system/components/UI/UIMedia.props'
import type { Authenticity } from '@integration-layer/ampliance/schemas/authenticity-schema.localized'

const props = defineProps<{
  deliveryId: string
  locale: string
  vse?: string
  content?: Authenticity
}>()
const data = await useComponentResponse<Authenticity>(props)

const mappedData: EditorialAuthenticityProps = {
  title: data.value?.title!,
  text: data.value?.text!,
  instructionTitle: data.value?.instructionTitle,
  instructionText: data.value?.instructionText,
  image: data.value?.image as unknown as UIMediaProps,
  liveStory: data.value?.liveStory as unknown as EditorialSocialWallProps,
}
</script>

<template>
  <EditorialAuthenticity v-bind="mappedData" />
</template>
